export const strToSlug = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s/g, "_");
};



// WEBPACK FOOTER //
// ./src/views/Calendar/util/strToSlug.js